export const messages = {
    primary: {
        backgroundColor: 'baseBg',
        color: 'baseTextWeak',
    },
    secondary: {
        backgroundColor: 'neutralBgStrong',
        color: 'neutralText',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUvbWVzc2FnZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sUUFBUSxHQUFnQjtJQUNuQyxPQUFPLEVBQUU7UUFDUCxlQUFlLEVBQUUsUUFBUTtRQUN6QixLQUFLLEVBQUUsY0FBYztLQUN0QjtJQUNELFNBQVMsRUFBRTtRQUNULGVBQWUsRUFBRSxpQkFBaUI7UUFDbEMsS0FBSyxFQUFFLGFBQWE7S0FDckI7Q0FDRixDQUFDIn0=